( function( global, undefined ) {
  if( !Object.values ) 
    Object.values = o => Object.keys( o ).map( k => o[k] );
})( this );